import './styles/CustomQuestion.css';

const CustomQuestion: React.FC = () => {
  return (
    <div className="custom-question-container">
      <div className="metric-board-area">
        The sun beat down on the dusty trail, casting long shadows from the
        sparse trees that lined it. A lone rider, a young woman with fiery red
      </div>
      <div className="quiz-input-area">Result side of question</div>
    </div>
  );
};

export default CustomQuestion;
